import { IsNumberString, IsOptional, IsString, Length } from 'class-validator';

export class GiftCardCheckRequest {
  @IsString()
  cardNumber: string;

  @IsOptional()
  @IsNumberString()
  @Length(3, 3)
  cvvCode?: number;
}
